// Vendor libraries
import cloneDeep from 'lodash.clonedeep';
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { addModule, addPage, removePage, moveModule, removeModule, setReportModules, movePage, duplicatePage, updateModule, } from './modules.action';
import { setIncludeBenchmarkDefault } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/include-benchmark-default/include-benchmark-default.action';
export const modules = createReducer([], on(setCustomPDFReportBuilderStore, setReportModules, (state, action) => {
    return action.modules;
}), on(setIncludeBenchmarkDefault, (state, action) => {
    return state.map((page) => {
        return page.map((module) => {
            if ('include_benchmark' in module.customizable_fields) {
                const updatedModule = cloneDeep(module);
                updatedModule.customizable_fields.include_benchmark.value = action.include_benchmark_default;
                return updatedModule;
            }
            return module;
        });
    });
}), on(addPage, (state, action) => {
    const newState = cloneDeep(state);
    newState.splice(action.insertAfter + 1, 0, []);
    return newState;
}), on(duplicatePage, (state, action) => {
    const newState = cloneDeep(state);
    let duplicatedPage = cloneDeep(newState[action.page]);
    duplicatedPage = duplicatedPage.map((module) => {
        return { ...module, module_id: null };
    });
    newState.splice(action.page + 1, 0, duplicatedPage);
    return newState;
}), on(removePage, (state, action) => {
    const newState = cloneDeep(state);
    newState.splice(action.page, 1);
    return newState;
}), on(movePage, (state, action) => {
    const newState = cloneDeep(state);
    newState.splice(action.targetPage, 0, newState.splice(action.prevPage, 1)[0]);
    return newState;
}), on(addModule, (state, action) => {
    const newState = cloneDeep(state);
    const newModule = cloneDeep(action.module);
    newState[action.page] = newState[action.page].concat(newModule);
    return newState;
}), on(updateModule, (state, action) => {
    const newState = cloneDeep(state);
    newState[action.page][action.index] = {
        ...newState[action.page][action.index],
        preview_image_url: action.module.preview_image_url,
        warning: action.module.warning,
        x_coordinate: action.module.x_coordinate,
        y_coordinate: action.module.y_coordinate,
        customizable_fields: { ...action.module.customizable_fields },
    };
    return newState;
}), on(removeModule, (state, action) => {
    const newState = cloneDeep(state);
    newState[action.page].splice(action.index, 1);
    return newState;
}), on(moveModule, (state, action) => {
    const newState = cloneDeep(state);
    // If moving within a page, swap modules
    if (action.prevPage === action.targetPage) {
        newState[action.prevPage].splice(action.targetIndex, 0, newState[action.prevPage].splice(action.prevIndex, 1)[0]);
    }
    else {
        // Add to the target page
        newState[action.targetPage].splice(action.targetIndex, 0, newState[action.prevPage][action.prevIndex]);
        // Remove from the previous page
        newState[action.prevPage].splice(action.prevIndex, 1);
    }
    return newState;
}));
